import { Button } from "@/components/ui/button";
import React from "react";
export interface FooterProps {
  title: string;
  landing_page: string;
  cta_label: string;
}
const Footer = ({ title, landing_page, cta_label }: FooterProps) => {
  const handleCTAClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (landing_page) {
      window.open(landing_page, "_blank");
    }
  };

  const hasContent = Boolean(landing_page || title || cta_label);
  if (!hasContent) return <></>;

  return (
    <div className="w-full flex items-center justify-between py-[13px]">
      <div className="flex-1 flex flex-col justify-between min-w-0">
        {landing_page && (
          <p className="text-brand-primary-600 text-[12px] font-normal leading-[16px] overflow-hidden text-ellipsis whitespace-nowrap">
            {landing_page?.split("/")[2]?.replace("www.", "")}
          </p>
        )}
        {title && (
          <p className="text-brand-primary-800 text-[14px] font-normal leading-[16px] overflow-hidden text-ellipsis whitespace-nowrap">
            {title}
          </p>
        )}
      </div>
      {cta_label && (
        <Button onClick={handleCTAClick} className="ml-2">
          {cta_label}
        </Button>
      )}
    </div>
  );
};

export default Footer;
